import { Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { appRoutes } from './routes'
import AppLayout from './components/AppLayout'

import '@/assets/scss/style.scss'

const App = () => {
  return (
    <Suspense fallback={<div className="text-center py-4">Yükleniyor...</div>}>
      <Routes>
        {appRoutes.map((route) => {
          if (route.children) {
            return (
              <Route key={route.path} path={route.path}>
                {route.children.map((child) => (
                  <Route 
                    key={child.path} 
                    path={child.path} 
                    element={
                      child.path === 'login' ? 
                        child.element : 
                        <AppLayout>{child.element}</AppLayout>
                    } 
                  />
                ))}
              </Route>
            )
          }
          return (
            <Route 
              key={route.path} 
              path={route.path} 
              element={<AppLayout>{route.element}</AppLayout>} 
            />
          )
        })}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  )
}

export default App
